module.exports = __webpack_public_path__ + "static/pixel-union-logo-1c65a102047ae3b76af8efc09cde0593.png";